import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
    name: 'forgeMarkdown',
    standalone: false
})
export class ForgeMarkdownPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string): SafeHtml {
    if (!value) return '';

    let html = value
      // Bold
      .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
      // Italic
      .replace(/\*(.+?)\*/g, '<em>$1</em>')
      // Table rows (| col | col |)
      .replace(/^\|(.+)\|$/gm, (_, row) => {
        const cells = row.split('|').map((c: string) => c.trim());
        const isHeader = cells.some((c: string) => /^-+$/.test(c));
        if (isHeader) return '';
        return '<tr>' + cells.map((c: string) => `<td>${c}</td>`).join('') + '</tr>';
      })
      // Wrap consecutive <tr> in a table
      .replace(/((<tr>.*<\/tr>\n?)+)/g, '<table class="forge-table">$1</table>')
      // Horizontal rule (---)
      .replace(/^---$/gm, '<hr class="forge-hr"/>')
      // Headings
      .replace(/^### (.+)$/gm, '<h4>$1</h4>')
      .replace(/^## (.+)$/gm, '<h3>$1</h3>')
      // Unordered list items
      .replace(/^- (.+)$/gm, '<li>$1</li>')
      .replace(/(<li>.*<\/li>\n?)+/g, '<ul>$&</ul>')
      // Numbered list items
      .replace(/^\d+\. (.+)$/gm, '<li>$1</li>')
      // Paragraphs (double newline)
      .replace(/\n\n/g, '</p><p>')
      // Single newlines to <br> within paragraphs
      .replace(/\n/g, '<br/>');

    html = '<p>' + html + '</p>';

    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}
